import { useEffect } from "react";

import classNames from "classnames";

import { DEPRECATED_Loading } from "@jti/ui/components/DEPRECATED_Loading";
import { useBodyScrollLock } from "@jti/ui/hooks/useBodyScrollLock";

import "./style.scss";

type LoadingLayerType = {
  isVisible: boolean;
  testId?: string;
  transparentBackground?: boolean;
};

export const LoadingLayer = ({ isVisible, testId, transparentBackground = true }: LoadingLayerType) => {
  const { toggleScroll } = useBodyScrollLock(isVisible);

  useEffect(() => {
    toggleScroll(isVisible);
  }, [isVisible]);

  if (!isVisible) {
    return null;
  }

  const className = classNames("loading-layer", {
    "loading-layer--white": !transparentBackground,
  });

  return (
    <div className={className} data-testid={testId}>
      <div className={"loading-layer__backdrop"}></div>
      <div className={"loading-layer__content"}>
        <DEPRECATED_Loading />
      </div>
    </div>
  );
};
